import React from 'react'
import './Features.css'

interface Feature {
  icon: string
  title: string
  description: string
}

const features: Feature[] = [
  {
    icon: '🏭',
    title: 'Complete Roll Forming Lines',
    description: 'End-to-end production systems with uncoilers, roll formers, cut-off systems, and stackers designed for high-volume manufacturing.'
  },
  {
    icon: '🔧',
    title: 'Custom Roll Tooling',
    description: 'Precision-engineered dies and rolls manufactured to .003" tolerances for complex profiles and specialized applications.'
  },
  {
    icon: '🏗️',
    title: 'Uncoilers & Presses',
    description: 'Heavy-duty uncoiling and pressing equipment for continuous material feeding and precision forming operations.'
  }
]

const Features: React.FC = () => {
  return (
    <section className="features" id="products">
      <div className="container">
        <h2>Our Manufacturing Solutions</h2>
        <p className="section-subtitle">Comprehensive roll forming equipment and custom tooling for every application</p>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features